import React from "react"
import { createRoot } from "react-dom/client"
import ModalVacanciesForm from "./ModalVacanciesCv"

const renderModalVacanciesCv = (toOrderValue) => {
  const body = document.querySelector("body")
  let cartContainer = document.querySelector(".js_modal_vacancies_form_root")

  if (!cartContainer) {
    cartContainer = document.createElement("div")
    cartContainer.classList.add("js_modal_vacancies_form_root")

    // root && render(<ModalCertificateOrder />, root);
    body.appendChild(cartContainer)
  }

  if (cartContainer) {
    const root = createRoot(cartContainer)
    root.render(<ModalVacanciesForm toOrderValue={toOrderValue} />)
  }
}
export default renderModalVacanciesCv
